// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendors":"9a7d992c2fe53f8cd482","node_modules_babel-loader_lib_index_js_ruleSet_1_rules_2_src_taskpane_bootstrap_tsx":"cc45be9739ca5c846aa9"}[chunkId] + ".js";
};